module.exports = __webpack_public_path__ + "static/img/mode3-1.048575af.png";